import Header from "./components/Header";
import Footer from "./components/Footer";
import PdfForm from "./components/PdfForm";

function App() {
  return (
    <div>
      <Header />
      <PdfForm />
      <Footer />
    </div>
  );
}

export default App;
